module.exports = __webpack_public_path__ + "static/media/white-wall.afb68f6a.jpeg";